var _defs, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "flagpackGbUkm0",
    fill: "#fff",
    d: "M0 0h32v24H0z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "flagpackGbUkm1",
    width: 32,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#flagpackGbUkm0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    mask: "url(#flagpackGbUkm1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E42A5",
    fillRule: "evenodd",
    d: "M0 0v24h32V0H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "flagpackGbUkm2",
    width: 32,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0v24h32V0H0z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagpackGbUkm2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "flagpackGbUkm3",
    width: 32,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#flagpackGbUkm0"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagpackGbUkm3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m-3.563 22.285l7.042 2.979l28.68-22.026l3.715-4.426l-7.53-.995l-11.698 9.491l-9.416 6.396l-10.793 8.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "M-2.6 24.372L.989 26.1L34.54-1.599h-5.037l-32.102 25.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.563 22.285l-7.042 2.979L-.159 3.238l-3.715-4.426l7.53-.995l11.698 9.491l9.416 6.396l10.793 8.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m35.323 23.783l-3.588 1.728l-14.286-11.86l-4.236-1.324l-17.445-13.5H.806l17.434 13.18l4.631 1.588l12.452 10.188z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "flagpackGbUkm4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.778-2h-7.556V8H-1.972v8h14.194v10h7.556V16h14.25V8h-14.25V-2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    fillRule: "evenodd",
    d: "M19.778-2h-7.556V8H-1.972v8h14.194v10h7.556V16h14.25V8h-14.25V-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.222-2v-2h-2v2h2zm7.556 0h2v-2h-2v2zM12.222 8v2h2V8h-2zM-1.972 8V6h-2v2h2zm0 8h-2v2h2v-2zm14.194 0h2v-2h-2v2zm0 10h-2v2h2v-2zm7.556 0v2h2v-2h-2zm0-10v-2h-2v2h2zm14.25 0v2h2v-2h-2zm0-8h2V6h-2v2zm-14.25 0h-2v2h2V8zm-7.556-8h7.556v-4h-7.556v4zm2 8V-2h-4V8h4zm-16.194 2h14.194V6H-1.972v4zm2 6V8h-4v8h4zm12.194-2H-1.972v4h14.194v-4zm2 12V16h-4v10h4zm5.556-2h-7.556v4h7.556v-4zm-2-8v10h4V16h-4zm16.25-2h-14.25v4h14.25v-4zm-2-6v8h4V8h-4zm-12.25 2h14.25V6h-14.25v4zm-2-12V8h4V-2h-4z",
    mask: "url(#flagpackGbUkm4)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUk);
export default __webpack_public_path__ + "static/media/ic_UK.c4d05bee7a97c3df81aa7587d3fea080.svg";
export { ForwardRef as ReactComponent };